import { buildEducationFormSchema } from '../../../../../common';

export const EDUCATION_INFO_SCHEMA = buildEducationFormSchema();
